// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-admin-js": () => import("./../../../src/pages/admin.js" /* webpackChunkName: "component---src-pages-admin-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-bill-page-js": () => import("./../../../src/templates/bill-page.js" /* webpackChunkName: "component---src-templates-bill-page-js" */),
  "component---src-templates-embed-carousel-billstowatch-js": () => import("./../../../src/templates/embed-carousel-billstowatch.js" /* webpackChunkName: "component---src-templates-embed-carousel-billstowatch-js" */),
  "component---src-templates-embed-carousel-js": () => import("./../../../src/templates/embed-carousel.js" /* webpackChunkName: "component---src-templates-embed-carousel-js" */)
}

